<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :show-close="false"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="bullet-detail"
    >
      <div slot="title" class="dialog-title dialog-top">
        <div class="dialog-detail">
          <span class="detail">{{ $lang('问题件详情') }}</span>
        </div>
        <img class="dialog-close" src="@/assets/images/close.png" alt="" @click="viewDialogVisible = false" />
      </div>
      <div class="dialog-center">
        <div class="dialog-step1">
          <div class="dialog-step1-ct">
            <div class="dialog-step1-list">
              <p class="dialog-step1-t1">{{ $lang('运单编号') }}：</p>
              <p class="dialog-step1-t2">{{ rowData.waybillNo }}</p>
            </div>
            <div class="dialog-step1-list">
              <p class="dialog-step1-t1">{{ $lang('揽收时间') }}：</p>
              <p class="dialog-step1-t2">{{ rowData.deliveryTime || '--' }}</p>
            </div>
            <!-- <div class="dialog-step1-list" style="margin-left: 16px">
              <div>
                <p class="dialog-step1-t1">{{ $lang('客户订单号') }}：</p>
                <p class="dialog-step1-t2">{{ rowData.inputTime }}</p>
              </div>
            </div> -->
          </div>
        </div>
        <div class="dialog-step2">
          <div class="dialog-step2-ct">
            <span class="dialog-step2-span">{{ $lang('寄方') }}</span>
            <div class="info">
              <div class="contact">
                <span class="dialog-step2-name ellipsis">{{ rowData.senderName }}</span>
                <span class="dialog-step2-phone">{{ '\xa0' + rowData.senderMobilePhone }}</span>
              </div>
              <div class="dialog-step2-adress">
                {{ rowData.senderProvinceName }}{{ rowData.senderCityName }}{{ countryId === 1 ? rowData.senderAreaName : '' }}{{ rowData.senderStreet !== undefined && rowData.senderStreet !== null ? rowData.senderStreet : ''
                }}{{ rowData.senderDetailedAddress }}
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-step2">
          <div class="dialog-step2-ct">
            <span class="dialog-step2-span get">{{ $lang('收方') }}</span>
            <div class="info">
              <div class="contact">
                <span class="dialog-step2-name ellipsis">{{ rowData.receiverName }}</span>
                <span class="dialog-step2-phone">{{ '\xa0' + rowData.receiverMobilePhone }}{{ rowData.receiverTelphone ? ' / ' + rowData.receiverTelphone : '' }}</span>
              </div>
              <div class="dialog-step2-adress">
                {{ rowData.receiverProvinceName }}{{ rowData.receiverCityName
                }}{{ countryId === 1 ? rowData.receiverAreaName : '' }}{{ rowData.receiverStreet !== undefined && rowData.receiverStreet !== null ? rowData.receiverStreet : '' }}{{ rowData.receiverDetailedAddress }}
              </div>
            </div>
          </div>
        </div>
        <div class="attribute-wrap">
          <div class="step3-list">
            <p class="step3-list-t1">{{ $lang('问题件一级类型') }}：</p>
            <p class="step3-list-t2">{{ rowData.probleTypeSubjectName || '--' }}</p>
          </div>
          <div class="step3-list">
            <p class="step3-list-t1">{{ $lang('问题件二级类型') }}：</p>
            <p class="step3-list-t2" :title="rowData.secondLevelTypeName">{{ rowData.secondLevelTypeName || '--' }}</p>
          </div>
          <div class="step3-list">
            <p class="step3-list-t1">{{ $lang('问题件原因') }}：</p>
            <p class="step3-list-t2">{{ rowData.probleDescription || '--' }}</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Detail',
  props: {
    rowData: {
      type: Object,
      default: _ => {
        return {}
      },
    },
  },
  data () {
    return {
      viewDialogVisible: false,
    }
  },
  computed: {
    countryId() {
      return this.$store.state.base.user.countryId || ''
    }
  },
  watch: {
    'rowData': {
      deep: true,
      handler (newVal, oldVal) {

      },
    },
  },

  methods: {
    showDialog () {
      this.viewDialogVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .dialog-detail {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .detail {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      font-weight: 600;
    }
    i {
      display: inline-block;
      border-radius: 50%;
      overflow: hidden;
      width: 8px;
      height: 8px;
      background: #fa8b14;
      margin-left: 16px;
      margin-right: 8px;
    }
    .detail-status {
      // width:36px;
      height: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFangSC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 12px;
    }
  }
  .dialog-close {
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
  }
}
.dialog-center {
  padding: 20px 15px;
  .dialog-step1 {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 16px;
    .dialog-step1-ct {
      height: 32px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .dialog-step1-list {
        width: 200px;
        height: 36px;
        .dialog-step1-t1 {
          width: 200px;
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 14px;
          margin: 0;
          margin-bottom: 8px;
        }
        .dialog-step1-t2 {
          width: 200px;
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin: 0;
        }
      }
    }
  }
  .dialog-step2 {
    padding: 16px 0;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .dialog-step2-ct {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .dialog-step2-span {
        width: 48px;
        height: 48px;
        background: #e60012;
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: #fff;
        line-height: 48px;
        text-align: center;
        &.get {
          background: #fff;
          color: #e60012;
          border: 1px solid #e60012;
        }
      }
      .info {
        margin-left: 24px;
        flex: 1;
        .contact {
          margin-bottom: 8px;
        }
      }
      .dialog-step2-name {
        max-width: 180px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        font-weight: 600;
      }
      .dialog-step2-phone {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
      }
      .dialog-step2-adress {
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .dialog-step3 {
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
  }
  .attribute-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .step3-list {
    width: 200px;
    height: auto;
    margin-top: 24px;
    .step3-list-t1 {
      width: 200px;
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFangSC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 14px;
      margin: 0;
    }
    .step3-list-t2 {
      width: 200px;
      height: auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
      margin: 0;
      margin-top: 8px;
      &.wrap-text {
        overflow: inherit;
        white-space: initial;
      }
    }
  }
  .dialog-step4 {
    width: 100%;
    height: 142px;
    overflow-y: auto;
    border-bottom: 1px solid #eee;
    border-top: 1px solid #eee;
    margin-top: 16px;
    .step4-list {
      width: 100%;
      height: 14px;
      margin-bottom: 24px;
      color: #999;
      .common-t1 {
        display: block;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        line-height: 14px;
        float: left;
      }

      .step4-status {
        width: 14px;
        height: 14px;
        display: block;
        position: relative;
        margin-left: 16px;
        margin-right: 8px;
        // overflow: hidden;
        float: left;
        .status-name {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 14px;
          color: #fff;
          position: absolute;
          font-size: 8px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
        }
        .status-line {
          position: absolute;
          left: 0;
          right: 0;
          top: -20px;
          margin: auto;
          width: 1px;
          height: 16px;
          background: rgba(221, 221, 221, 1);
          border-radius: 1px;
          z-index: 100;
        }
      }
    }
    .step4-list:first-of-type {
      margin-top: 16px;
      .status-line {
        display: none;
      }
    }
    .step4-list:last-of-type {
      margin-bottom: 16px;
    }
  }
}
</style>
<style lang="scss">
.el-dialog__wrapper.bullet-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 600px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
</style>
